import Image from '@base/Image';
import useWindowSize from '@hooks/useWindowSize';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';

const StaticInfoImageWrapper = styled.div`
  width: 100%;
  margin-top: ${Spacings.SPACING_6B};
`;

const ImageWrapper = styled.div`
  position: relative;
  width: ${Spacings.SPACING_24B};
  height: ${Spacings.SPACING_20B};
  img {
    border-radius: ${Spacings.SPACING_2B};
  }
`;

const HeadingWrapper = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.H4};
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Spacings.SPACING_5B};
  margin-top: ${Spacings.SPACING_4B};
`;

const HR = styled.hr`
  background-color: var(--color-i-green-99);
  height: 1px;
  border: none;
  margin-top: ${Spacings.SPACING_4B};
`;

const EnquiryStaticInfoImage = () => {
  const { isMobile } = useWindowSize();

  return (
    <StaticInfoImageWrapper>
      <ImageWrapper>
        <Image
          src="allCentre/EnquiryFormImage.svg"
          alt="all-centre-enquiry-form"
          layout="fill"
        />
      </ImageWrapper>
      {isMobile && (
        <HeadingWrapper>
          Book a call with us for any query regarding centres
        </HeadingWrapper>
      )}
      {isMobile && <HR />}
    </StaticInfoImageWrapper>
  );
};

export default EnquiryStaticInfoImage;
